export { ToggleSwitchCore } from './ToggleSwitchCore';
export type { ToggleSwitchCoreProps } from './ToggleSwitchCore';
